const DEFAULT_TIMEOUT = 3000;
import Alerts from './alert-types';

class AlertManager {
    alerts = [];
    container = document.getElementById('alert-container');
    timer;

    addAlertToDom({ type, message }) {
        const sidebarToggled = localStorage.getItem('sidebar-toggled') == 'true';

        this.container.innerHTML = `
            <div class='alert-item ${sidebarToggled ? 'alert-item--sidebar-toggled' : ''} alert-item--${type} animated fadeIn utils__row'>
                <div class='alert-item__left'>
                    <div class='alert-item__head'>${type}</div>
                    <div class='alert-item__inner'>
                        <p>${message}</p>
                    </div>
                </div>
                <div class="alert-item__right">
                    <button id="alert-item__exit" class="button button--${type} button--mobile">
                        <div>
                            <img src='/assets/buttons/cancel-icon.svg'/>
                        </div>
                    </button>
                </div>
            </div>
        `;

        const exit = document.getElementById('alert-item__exit');

        exit.onclick = () => {
            if (this.timer != null) clearTimeout(this.timer);

            this.nextAlert();
        }
    };

    success(message, timeout = DEFAULT_TIMEOUT) {
        this.addAlert({
            type: Alerts.SUCCESS ,
            message,
            timeout
        });
    }
    error(message, timeout = DEFAULT_TIMEOUT) {
        this.addAlert({
            type : Alerts.ERROR,
            message,
            timeout
        })
    }

    addAlert({ type, message, timeout = DEFAULT_TIMEOUT }) {
        // Alert gets added
        // - If no alert before then show it and fade out
        // - If there is an alert already keep showing it until it fades out then show next one

        const alert = { type, message, timeout, id: this.alerts.length };

        this.alerts.push(alert);

        this.timer = setTimeout(() => this.nextAlert(), timeout);

        this.addAlertToDom(alert);
    }

    nextAlert() {
        const alert = document.querySelector('.alert-item');
        alert?.classList.add('fadeOut');

        this.alerts = this.alerts.filter(({ id }) => id != this.alerts[0].id);

        if (this.alerts.length == 0) {
            if (this.timer != null) clearTimeout(this.timer);

            setTimeout(() => this.container.innerHTML = '', 400);
        } else {
            const alert = this.alerts[0];

            this.timer = setTimeout(() => this.nextAlert(), alert.timeout);
            this.addAlertToDom(alert);
        }
    }
}

export default new AlertManager;
